import { compose, lifecycle, withHandlers, withPropsOnChange, withState } from 'recompose';
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";
import withWindowSize from "react-window-size";
import { path } from "ramda";
import * as Yup from "yup";
import { t } from "i18next";

import ProfileComponent from "./profileComponent";

import { companyActions } from '../../../modules/company';
import { profileAction } from "../../../modules/profile";
import { authActions } from "../../../modules/auth";

import { withForm } from '../../../utils/enhancers';
import { withLanguageOnChange } from '../../../utils/enhancers/withLanguageChange';
import withGATracker from '../../../utils/enhancers/withGATracker';

export const PROFILE_TABS = {
  comments: {
    index: 0,
    text: 'profile.profileTabs.comments'
  },
  settings: {
    index: 1,
    text: 'profile.profileTabs.settings'
  }
};

export const TYPE_USER = {
  COMPANY: 'company',
  USER: 'user',
};

const { fetchProfileReview } = profileAction;
const { updateCompany, removeLogo, updateCompanyLogo } = companyActions;
const { updateActiveUser, updateActiveUserAvatar, deleteActiveUserAvatar } = authActions;

const enhance = compose(
  connect(({ router, auth, profile, company }) => ({
    location: router.location,
    company: auth.activeUser || fetchProfileReview,
    reviewCount: profile.countReview,
    reviews: profile.reviews,
    isReviewsLoading: profile.loading,
    profileData: profile,
    isUserUpdate: auth.updatingActiveUser,
    isCompanyUpdate: company.loading,
  }), {
    goBack,
    push,
    fetchProfileReview,
    updateCompany,
    updateCompanyLogo,
    deleteActiveUserAvatar,
    updateActiveUserAvatar,
    removeLogo,
    updateActiveUser
  }),
  withWindowSize,
  withLanguageOnChange,
  withGATracker,
  withState('activeTab', 'changeActiveTab', PROFILE_TABS.settings),
  withState('typeUser', 'setTypeUser', TYPE_USER.USER),
  withState('isChangeAvatarOpened', 'toggleChangeAvatarModal', false),
  withState('isChangePassOpen', 'toggleChangePass', false), // leave it as will be implemented.
  withHandlers({
    handleActiveTabs: ({ changeActiveTab }) => (tab) => {
      changeActiveTab(tab);
    },
    onPagination: ({ fetchProfileReview }) => () => {
      fetchProfileReview();
    },
    updateAvatar: ({ company, updateCompanyLogo, updateActiveUserAvatar, toggleChangeAvatarModal, typeUser }) => ({ target }) => {
      if (typeUser === TYPE_USER.COMPANY) {
        const formData = new FormData();
        formData.append('logo', target.files[0]);
        updateCompanyLogo({_id: company._id, formData});
      }
      else {
        const avatar = new FormData();
        avatar.append('avatar', target.files[0]);
        updateActiveUserAvatar(avatar);
      }

      toggleChangeAvatarModal(false);
    },
    removeAvatar: ({ typeUser, company, removeLogo, deleteActiveUserAvatar, toggleChangeAvatarModal }) => () => {
      if (typeUser === TYPE_USER.COMPANY) {
        removeLogo(company._id);
      }
      else {
        deleteActiveUserAvatar();
      }
      toggleChangeAvatarModal(false);
    },
  }),
  withPropsOnChange(['typeUser', 'company'] ,({ company, setTypeUser }) => {
      if (company && company.base) {
        setTypeUser(TYPE_USER.COMPANY);
      } else {
        setTypeUser(TYPE_USER.USER);
      }
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchProfileReview()
    }
  }),

  withForm({
    mapPropsToValues: ({ company }) => (
    {
      name: path(['name'], company) || '',
      email: (path(['base', 'email'], company) || path(['email'], company) || ''),
    }),
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required(t('forms.login.errors.email.required'))
    }),
    handleSubmit: (values, {setSubmitting, props: { company, typeUser, updateCompany, updateActiveUser}}) => {
      setSubmitting(true);

      const dataToUpdate = typeUser === TYPE_USER.COMPANY ? {
        _id: company._id,
        name: values.name,
        logo: company.logo || null,
        base: {
          email: values.email
        }
      } : {
        _id: company._id,
        name: values.name,
        logo: company.logo || null,
        email: values.email,
      };
      if (typeUser === TYPE_USER.COMPANY) {
        updateCompany(dataToUpdate);
      } else {
        updateActiveUser(dataToUpdate);
      }
    },
  }),
);

export default enhance(ProfileComponent)
